export default {
  items: [
    {
      name: 'Leave Soon',
      url: '/leaveSoon',
      icon: 'fa fa-car',
    },
    {
      name: 'Schedule',
      url: '/schedule',
      icon: 'fa fa-calendar',
    },
    {
      name: 'Settings',
      url: '/settings',
      icon: 'fa fa-cog',
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js